import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@workos-inc/authkit-react";
import { Box, CircularProgress } from "@mui/material";

interface RequirePermissionProps {
  /** Single permission, or a list — access is granted if the user holds ANY of them. */
  permission: string | string[];
  children: React.ReactNode;
}

export function RequirePermission({
  permission,
  children,
}: RequirePermissionProps) {
  const { isLoading, permissions } = useAuth();
  const required = Array.isArray(permission) ? permission : [permission];

  if (isLoading) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: "100vh",
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  if (!required.some((p) => permissions.includes(p))) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
}
